import React, { useState, useEffect } from "react";
import { appFetchJson, apiFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";

// Reutilizables
//import ComboSelectEess from "../../../components/Modales/ComboSelectEess";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import ComboMultiSelectClientes from "../../../components/Modales/ComboMultiSelectClientes";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import ModalBase from "../../../components/Modales/ModalBase";

export default function CrearInformacion({
  clientes = [],
  clientesLoading = false,
  onClose = () => {},
  onCreated = () => {},
}) {
  const [fecha, setFecha] = useState("");
  const [descripcion, setDescripcion] = useState("");

  // ===== CLIENTES (precarga única) =====
  const [selectedClientes, setSelectedClientes] = useState([]);

  // ===== EE.SS =====
  const [selectedEess, setSelectedEess] = useState(null);

  const isValid =
    fecha.trim() !== "" &&
    descripcion.trim() !== "" &&
    selectedClientes.length > 0;

  const [saving, setSaving] = useState(false);

  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);

    try {
      const payload = {
        fecha,
        descripcion,
        clienteIds: selectedClientes,
        eessId: selectedEess ? selectedEess.id : null,
        tarjetaId: null,
      };

      await appFetchJson(apiRoutes.informacion.create, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      onCreated();
      onClose();
    } catch (e) {
      console.error(e);
      alert("No se pudo guardar la información");
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalBase
      title="Crear Información"
      onClose={onClose}
      footer={
        <div className="btn-row">
          <BtnGuardar isValid={isValid} saving={saving} onClick={guardar} />
          <BtnCancelar onClick={onClose} />
        </div>
      }
    >
      {/* FECHA */}
      <div className="grid grid-cols-[140px_1fr] items-start gap-3 max-w-3xl">
        <label className="label-strong text-right mt-2">Fecha *</label>
        <input
          type="date"
          className="input w-full"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
        />
      </div>

      {/* DESCRIPCIÓN */}
      <div className="grid grid-cols-[140px_1fr] items-start gap-3 max-w-3xl">
        <label className="label-strong text-right mt-2">Descripción *</label>
        <input
          type="text"
          className="input w-full"
          placeholder="Descripción…"
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
        />
      </div>

      {/* CLIENTES */}
      <div className="grid grid-cols-[140px_1fr] items-start gap-3 max-w-3xl">
        <label className="label-strong text-right mt-2">Clientes *</label>
        <ComboMultiSelectClientes
          items={clientes}
          loading={clientesLoading}
          selected={selectedClientes}
          onChange={setSelectedClientes}
        />
      </div>

      {/* EE.SS */}
      <div className="grid grid-cols-[140px_1fr] items-start gap-3 max-w-3xl">
        <label className="label-strong text-right mt-2">EE.SS</label>
        <EessAutocomplete
          value={selectedEess}
          onChange={setSelectedEess}
          placeholder="Buscar EE.SS..."
        />
      </div>
    </ModalBase>
  );
}
